const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoTeal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1787 348",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M338.53,0l-329.46,0c-5.01,0 -9.07,4.06 -9.07,9.07l-0,329.46c-0,5.01 4.06,9.07 9.07,9.07l329.46,0c5.01,0 9.07,-4.06 9.07,-9.07l-0,-329.45c0,-5.01 -4.06,-9.08 -9.07,-9.08Zm-247.71,271.39l-52.63,0l31.49,-148.43c14.39,-68.37 47.23,-89.96 115.6,-89.96l35.54,-0l-8.55,40.48l-22.04,-0c-42.28,-0 -61.62,21.14 -70.62,63.42l-28.79,134.49Zm189.82,-48.34c-14.39,68.37 -47.23,89.96 -115.6,89.96l-35.54,0l8.55,-40.48l22.04,0c42.28,0 61.62,-21.14 70.62,-63.42l28.79,-134.49l52.62,0l-31.48,148.43Z",
    style: {
      fill: "#0A5F6F",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M465.26,156.32l0,116.61l41.35,-0l0,-105.66c0,-33.22 8.13,-49.83 41.35,-49.83l6.71,-0l0,-31.8l-17.32,-0c-50.18,-0 -72.09,20.5 -72.09,70.68Z",
    style: {
      fill: "#0A5F6F",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.54,83.52c-63.61,0 -85.52,21.2 -85.52,95.41c0,74.92 21.91,96.12 85.52,96.12c63.61,0 85.52,-21.2 85.52,-96.12c0,-74.21 -21.91,-95.41 -85.52,-95.41Zm0,159.73c-35.34,0 -42.76,-18.38 -42.76,-64.32c0,-45.94 7.42,-63.61 42.76,-63.61c35.34,0 42.76,17.67 42.76,63.61c0,45.94 -7.42,64.32 -42.76,64.32Z",
    style: {
      fill: "#0A5F6F",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 761.73,
    y: 25.57,
    width: 41.35,
    height: 247.36,
    style: {
      fill: "#0A5F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.07,157.73c0,-60.07 -26.5,-74.21 -75.98,-74.21c-60.07,-0 -76.33,21.2 -76.33,95.41c0,60.07 14.13,94 70.68,94l75.62,0l0,-31.8l-63.25,0c-31.8,0 -40.29,-19.79 -40.29,-48.06l80.57,0c21.2,0 28.98,-14.14 28.98,-35.34Zm-51.95,3.53l-57.6,0c-0,-31.8 5.3,-45.94 33.57,-45.94c21.2,0 33.22,10.25 33.22,34.98c-0,5.31 -1.06,10.96 -9.19,10.96Z",
    style: {
      fill: "#0A5F6F",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1093.92,153.81l-0,116.61l41.34,-0l-0,-105.66c-0,-33.22 8.13,-49.83 41.35,-49.83l6.71,-0l-0,-31.8l-17.32,-0c-50.17,0.01 -72.08,20.5 -72.08,70.68Z",
    style: {
      fill: "#0A5F6F",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1345.52,155.23c0,-60.07 -26.5,-74.21 -75.98,-74.21c-60.07,-0 -76.33,21.2 -76.33,95.41c0,60.07 14.13,94 70.68,94l75.62,0l0,-31.8l-63.25,0c-31.8,0 -40.29,-19.79 -40.29,-48.06l80.57,0c21.21,0 28.98,-14.14 28.98,-35.34Zm-51.95,3.53l-57.6,0c-0,-31.8 5.3,-45.94 33.57,-45.94c21.2,0 33.22,10.25 33.22,34.99c-0,5.3 -1.06,10.95 -9.19,10.95Z",
    style: {
      fill: "#0A5F6F",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1375.2,
    y: 23.06,
    width: 41.34,
    height: 247.36,
    style: {
      fill: "#0A5F6F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1538.1,83.14l-78.1,-0l-0,31.8l63.25,-0c17.67,-0 26.15,9.19 26.15,26.86l-0,12.01l-56.54,-0c-31.8,-0 -46.65,22.97 -46.65,58.31c-0,38.87 14.84,58.31 46.65,58.31l66.08,-0c21.2,-0 31.8,-10.6 31.8,-31.8l-0,-100.36c0.02,-31.81 -17.3,-55.13 -52.64,-55.13Zm11.31,144.88c-0,7.07 -3.53,10.6 -10.6,10.6l-30.04,0c-14.13,0 -19.79,-8.83 -19.79,-26.5c-0,-17.67 5.65,-26.5 19.79,-26.5l40.64,0l-0,42.4Z",
    style: {
      fill: "#0A5F6F",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1744.47,83.14l-44.53,136.76l-50.88,-136.76l-42.76,0l73.5,187.29l-22.26,60.43l42.05,0l86.93,-247.72l-42.05,0Z",
    style: {
      fill: "#0A5F6F",
      fillRule: "nonzero"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTeal);
export default __webpack_public_path__ + "static/media/logo-teal.4ce12dce67e7a76bb82251eb600d3241.svg";
export { ForwardRef as ReactComponent };